export default __webpack_public_path__ + "static/media/user-profile-white.61c5bc4f.svg";